import { useAppTranslation } from '@flowus/common/i18n/use-translation';
import type { FC } from 'react';
import { Tab } from 'src/common/components/tab/tab';
import { TabPane } from 'src/common/components/tab/tab-panel';
import { useCurrentSpaceUsers } from 'src/hooks/space/use-current-space-users';
import { useGuestsList } from 'src/services/app';
import { SettingModalCommon } from '../common';
import { useCloseSettingModal } from '../use-open-setting-modal';
import { Guests } from './guest';
import { Members } from './member';
import { MemberGroups } from './member-group';

/** 空间成员 */
export const MembersSetting: FC = () => {
  const { t } = useAppTranslation();
  const closeSettingModal = useCloseSettingModal();
  const users = useCurrentSpaceUsers();
  const spaceUser = Object.values(users);
  const guests = useGuestsList();

  return (
    <>
      <div className={SettingModalCommon.commonStyles.container}>
        <Tab tabBarClassName="px-0">
          <TabPane
            title={[t('common.member'), spaceUser.length ? `（${spaceUser.length}）` : ''].join('')}
          >
            <Members />
          </TabPane>
          <TabPane title={t('common.member_group')}>
            <MemberGroups />
          </TabPane>
          <TabPane
            title={`${t('views.settings.upgrade.external_collaborators')}（${guests.length}）`}
          >
            <Guests />
          </TabPane>
        </Tab>
      </div>
      <SettingModalCommon.FooterBar
        cancelText={t('common.close')}
        cancel={() => closeSettingModal()}
      />
    </>
  );
};
